var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:({ background: 'url(' + _vm.imagePath(_vm.fileName) + ') no-repeat' }),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.emitEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }